import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';

const signals = [
  { label: 'Founder & CEO', sub: 'Govtelligence · AI Governance' },
  { label: 'McKinsey Forward', sub: 'Leadership & Consulting Programme' },
  { label: 'MSc Data Science', sub: 'Loughborough University' },
  { label: 'AI Adoption Strategist', sub: 'Prolific' },
  { label: 'Expert Panel', sub: 'Robin & Berry · Practera' },
  { label: 'BSc Economics (2:1)', sub: 'University of Westminster' },
  { label: 'Expert Consultant', sub: 'AlphaSights' },
  { label: 'J.P. Morgan · Goldman Sachs', sub: 'Job Simulations' },
  { label: 'Expert Consultant', sub: 'Tegus & Guidepoint' },
  { label: 'Project Expert', sub: 'NewtonX' },
  { label: 'AI Trainer', sub: 'Outlier' },
  { label: 'Business Analyst', sub: 'Alignerr' },
  { label: 'Founder & CEO', sub: 'Etokify AI Agency' },
  { label: '5★ Freelancer', sub: 'Upwork' },
  { label: 'Public Sector AI', sub: 'UK Digital Networks' },
  { label: '6 Languages', sub: 'English · Arabic · Hindi · Gujarati · Urdu · French' },
  { label: '1,000+ Engagements', sub: 'Expert Networks' },
  { label: 'AWS AI Scholar', sub: 'Udacity × AWS' },
  { label: 'Turing AI Talent', sub: 'Vetted Top AI & Data Science Network' },
  { label: 'Tangent Fast Track', sub: 'Competitive Tech Mentoring Programme' },
];

const CredSignal = ({ label, sub }) => (
  <div className="flex items-center gap-5 mx-8">
    <div className="flex flex-col gap-0.5">
      <span className="text-[11px] font-medium text-white/75 tracking-[0.06em] whitespace-nowrap">
        {label}
      </span>
      <span className="text-[10px] text-text-secondary tracking-[0.04em] whitespace-nowrap">
        {sub}
      </span>
    </div>
    <div className="w-1 h-1 rounded-full bg-white/15 flex-shrink-0" />
  </div>
);

const Credibility = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="relative py-5 border-y overflow-hidden"
      style={{ borderColor: 'rgba(255,255,255,0.06)' }}
    >
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-28 bg-gradient-to-r from-bg-primary to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-28 bg-gradient-to-l from-bg-primary to-transparent z-10 pointer-events-none" />

      <Marquee speed={30} gradient={false} pauseOnHover>
        {signals.map((s, i) => (
          <CredSignal key={i} label={s.label} sub={s.sub} />
        ))}
        {signals.map((s, i) => (
          <CredSignal key={`b-${i}`} label={s.label} sub={s.sub} />
        ))}
      </Marquee>
    </motion.div>
  );
};

export default Credibility;
